<app-header></app-header>
<div class="main-container d-flex">
    <app-sidebar></app-sidebar>
    <div class="container-fluid h-100p overflow-y-scroll leak-password-main px-2 px-sm-3 px-lg-4">
        <div class="top-section py-2 py-md-3">
            <div class="nav-actions-row">
                <div class="nav-tabs-container">
                    <button *ngIf="accessDetails?.leak_search_permission" type="button" class="nav-tab nav-tab-number" [class.active]="activeTab === 'number'" (click)="setTab('number')">
                        <i class="fas fa-sim-card custom-icon"></i>
                        <span>By Number</span>
                    </button>
                    <button *ngIf="accessDetails?.leak_search_permission" type="button" class="nav-tab nav-tab-email" [class.active]="activeTab === 'email'" (click)="setTab('email')">
                        <i class="fas fa-at custom-icon"></i>
                        <span>By Email</span>
                    </button>
                    <button *ngIf="accessDetails?.leak_search_permission" type="button" class="nav-tab nav-tab-username" [class.active]="activeTab === 'username'" (click)="setTab('username')">
                        <i class="fas fa-user custom-icon"></i>
                        <span>By Username</span>
                    </button>
                    <button *ngIf="accessDetails?.leak_search_permission" type="button" class="nav-tab nav-tab-password" [class.active]="activeTab === 'password'" (click)="setTab('password')">
                        <i class="fas fa-lock custom-icon"></i>
                        <span>By Password</span>
                    </button>
                </div>
                <div class="credits-display">
                    <div class="credits-inline">
                        <span class="credits-inline-label">Remaining:</span>
                        <span class="credits-inline-value"><i class="fas fa-spinner fa-spin" *ngIf="creditsLoading" aria-hidden="true"></i><ng-container *ngIf="!creditsLoading">{{ availableCredits | creditsLabel }}</ng-container></span>
                    </div>
                    <button class="buy-credits-btn" (click)="onBuyCreditsButtonClick()">
                        <i class="fas fa-coins credits-icon"></i>
                        Buy Credits
                    </button>
                </div>
            </div>
        </div>
        <div class="search-card-container" *ngIf="isServiceDisabled">
            <div class="service-disabled-warning">
                <div class="warning-icon"><i class="fas fa-exclamation-triangle"></i></div>
                <h2 class="warning-title">Search temporarily unavailable</h2>
                <p class="warning-message">We're experiencing a temporary service issue. You can still access and export your previous search history below.</p>
            </div>
        </div>
        <div class="search-card-container" *ngIf="!isServiceDisabled">
            <div class="search-card">
                                <h2 class="search-title">Search Password</h2>
                <p class="credit-cost-notice credit-cost-notice-leak-password px-2" *ngIf="searchCreditCost != null">Each search costs <strong>{{ searchCreditCost }}</strong> {{ searchCreditCost === 1 ? 'credit' : 'credits' }}. If no results are found credits will be refunded.</p>
                <div class="restricted-alert" appRestrictedAccessWarning><i class="fas fa-exclamation-circle alert-icon"></i><span class="alert-restricted">RESTRICTED ACCESS!</span><span class="alert-dot">.</span><span class="alert-authorized">Authorized Law Enforcement Use Only</span></div>
                <div class="multi-input-rows search-input-container" [class.is-multi-search]="isMultipleSearch">
                    <div class="password-input-group">
                        <input *ngIf="!isMultipleSearch" type="text" class="password-input" placeholder="Enter password" [(ngModel)]="singlePassword">
                        <textarea
                            *ngIf="isMultipleSearch"
                            class="multi-search-textarea"
                            rows="4"
                            placeholder="Enter passwords, one per line, max 5 passwords"
                            [(ngModel)]="textAreaInput"
                        ></textarea>
                    </div>
                    <button type="button" class="search-button rounded" (click)="onSearchSinglePasswordButtonClick()"><i class="fas fa-search"></i>Search</button>
                    <div class="search-options multi-search-toggle">
                        <label class="checkbox-option">
                            <input type="checkbox" class="checkbox-input" [(ngModel)]="isMultipleSearch" (ngModelChange)="onMultipleSearchChange()">
                            <span class="checkbox-text">Multi search</span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="loading-container" *ngIf="loadingJobIds || loadingRecentResults">
            <div class="spinner-border" role="status"></div>
            <p class="loading-text">Fetching results, please wait...</p>
        </div>
        <div class="results-section">
            <div class="results-header">
                <h3 class="results-title">Recent Leak Password Searches</h3>
                <p class="results-subtitle">Showing only your "Password" leak searches. Click any row to reopen the report.</p>
            </div>
            <div class="results-body p-2 p-md-4">
                <div class="results-controls">
                    <div class="filter-section"><select class="filter-select" [(ngModel)]="selectedFilterType" (ngModelChange)="onFilterTypeChange()">
                            <option *ngFor="let filterType of filterTypes" [value]="filterType.value">{{ filterType.label }}</option>
                        </select>
                        <div class="filter-input-container"><input *ngIf="selectedFilterType === 'password'" class="filter-input" type="text" placeholder="Search by content" [(ngModel)]="passwordFilter" (ngModelChange)="onPasswordFilterChange($event)"><input *ngIf="selectedFilterType === 'notes'" class="filter-input" type="text" placeholder="Search by content" [(ngModel)]="notesFilter" (ngModelChange)="onNotesFilterChange($event)">
                            <div class="date-filter-group" *ngIf="selectedFilterType === 'date-added'"><input class="filter-input date-input" type="date" [(ngModel)]="startDateFilter" (ngModelChange)="onStartDateFilterChange($event)"><input class="filter-input date-input" type="date" [(ngModel)]="endDateFilter" (ngModelChange)="onEndDateFilterChange($event)"></div>
                        </div>
                    </div>
                    <div class="action-buttons"><button class="action-btn delete-btn" (click)="onDeleteButtonClick()"><i class="fas fa-trash"></i>Delete</button></div>
                </div>
                <div class="results-table-container">
                    <table class="results-table">
                        <colgroup>
                            <col class="col-checkbox">
                            <col class="col-password">
                            <col class="col-status">
                            <col class="col-date">
                            <col class="col-time">
                            <col class="col-notes">
                        </colgroup>
                        <thead>
                            <tr>
                                <th class="checkbox-column"><input type="checkbox" class="table-checkbox" [checked]="recentResultsSelectAll.isSelected" (change)="onRecentResultsSelectAllClick()"></th>
                                <th>Password</th>
                                <th>Status</th>
                                <th>Date Added</th>
                                <th>Time</th>
                                <th>Notes</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="!loadingJobIds && !loadingRecentResults && (!recentResultsPaged?.length || recentResultsCount === 0)" class="no-data-row">
                                <td colspan="6" class="no-data-cell">No results yet. Search using the input above</td>
                            </tr>
                            <tr *ngFor="let recentResultPaged of recentResultsPaged" class="table-row">
                                <td class="checkbox-column"><input type="checkbox" class="table-checkbox" [checked]="recentResultPaged.isSelected" (click)="onRecentResultPagedClick($event, recentResultPaged)"></td>
                                <td class="password-column" (click)="goToSearchResultPage(recentResultPaged)">{{ recentResultPaged.query }}</td>
                                <td class="status-column">
                                    <span
                                        class="status-badge"
                                        [class.status-completed]="isRecentRowComplete(recentResultPaged)"
                                        [class.status-refreshing]="isRecentRowRefreshing(recentResultPaged)"
                                        [class.status-pending]="!isRecentRowComplete(recentResultPaged) && !isRecentRowRefreshing(recentResultPaged)"
                                    >
                                        {{ getRecentRowStatusLabel(recentResultPaged) }}
                                    </span>
                                </td>
                                <td class="date-column">{{ recentResultPaged.created_on | date : 'MMM d, y' }}</td>
                                <td class="time-column">{{ recentResultPaged.created_on | date : 'HH:mm:ss' }}</td>
                                <td class="notes-column" [title]="recentResultPaged.notes || ''">{{ truncateToWords(recentResultPaged.notes) || '-' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="pagination-container">
                    <div class="pagination-info">Showing {{ recentResultsPagedStartAndEnd.start }} of {{ recentResultsCount }} result</div>
                    <div class="pagination-controls">
                        <app-paginator [totalItems]="recentResultsCount" [itemsPerPage]="recentResultsPerPage" [currentPage]="recentResultsCurrentPage" (pageChange)="onRecentResultsPageChange($event)"></app-paginator>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>